import React from "react";
import "./styles.css";
import { Route, Link, BrowserRouter as Router } from "react-router-dom";
import { slide as Menu } from "react-burger-menu";

export default function NavBar() {
  return (
    <>
    <div className="NavBar">
      <div className="NavTitle">
      Nikey-Jay 🌹
      </div>
      <div className="menuVisible">
        <Link to="/" className="NavItems">
          Home
        </Link>
        <Link to="/gallery" className="NavItems">
          Gallery
        </Link>
      </div>
    </div>
      <div className="burgerVisible">
        <Menu>
          <Link to="/" className="menu-items">
            Home
          </Link>
          <br />
          <Link to="/gallery" className="menu-items">
            Gallery
          </Link>
        </Menu>
      </div>
    </>

  );
}
